import React from 'react';
import { useEstimationUnit } from './estimationUnit';

interface Props {
  /** Optional "Show" / "Units" prefix label. Defaults to "Show" to match the
   *  Forecast page toolbar. Pass `null` to omit it on tight headers. */
  label?: string | null;
  /** Extra class on the wrapping flex row. */
  className?: string;
}

/**
 * Compact Hours / Days segmented toggle matching the Forecast toolbar style
 * (`.forecast-unit-toggle`). All Estimation accuracy cards render this so a
 * single click flips units everywhere — choice is persisted via
 * `EstimationUnitProvider`.
 */
export const EstimationUnitToggle: React.FC<Props> = ({ label = 'Show', className }) => {
  const { unit, setUnit, hoursPerDay } = useEstimationUnit();
  return (
    <div
      className={`estimation-unit-toolbar${className ? ` ${className}` : ''}`}
      title={`1 day = ${hoursPerDay} hours`}
    >
      {label != null && <span className="estimation-unit-toolbar__label">{label}</span>}
      <div
        className="forecast-unit-toggle estimation-unit-toggle"
        role="group"
        aria-label="Show Hours or Days"
      >
        <button
          type="button"
          className={`forecast-unit-btn${unit === 'hours' ? ' active' : ''}`}
          aria-pressed={unit === 'hours'}
          onClick={() => setUnit('hours')}
        >
          Hours
        </button>
        <button
          type="button"
          className={`forecast-unit-btn${unit === 'days' ? ' active' : ''}`}
          aria-pressed={unit === 'days'}
          onClick={() => setUnit('days')}
        >
          Days
        </button>
      </div>
    </div>
  );
};
